import name from './name'
import * as selectors from './selectors'
import reducer, * as actions from './slice'

export default {
  actions,
  name,
  reducer,
  selectors
}
